<template>
    <v-app>
      <Drawer current_item="menu_customer_billing"></Drawer>
      
      <v-main class="ml-6 mr-6">
        <v-card outlined class="pa-3">
                <v-card-title >
                    <v-row align="end" justify="space-between">
                        <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                            <strong>{{$t('customer_billing_title')}}</strong>
                            </v-col>
                        <v-col cols="12" md="4" align="left">
                            <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
                        </v-col>
                    </v-row>
                
                </v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div >
                    <v-card  >
                        <v-card-subtitle>
                            <v-row>
                            <v-col cols="2" style="text-align:left!important" class="mb-n8">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="date"
                                            label="เดือนที่แสดงข้อมูล"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date"
                                        @change="reloadMonth()"
                                        type="month"
                                        no-title
                                        :show-current="false"
                                        scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="menu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.menu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                                 <!--<strong>ข้อมูล ณ วันที่ {{currentDate}}</strong>-->
                             </v-col>
                             <!--<v-col style="text-align:right!important">จำนวนข้อความที่ใช้</v-col>
                             <v-col style="text-align:right!important">
                                 
                                 <v-progress-linear
                                             v-model="lineMessage.current"
                                             height="25"
                                            >
                                        <strong>{{lineMessageProgress}}</strong>
                                    </v-progress-linear>
                             </v-col>-->
                            </v-row>
                        </v-card-subtitle>
                        <v-divider class="ml-3"></v-divider>
                        <v-card-text  style="text-align:left!important;margin-left:20px;">
                            <v-row>
                                <!--
                                <v-col>
                                    <v-card>
                                        <v-card-subtitle>ข้อมูลลูกค้า</v-card-subtitle>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <v-row >
                                                <v-col cols="4">ชื่อ :</v-col>
                                                <v-col cols="6">{{customer.customer_name}}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">เลขประจำตัวผู้เสียภาษี :</v-col>
                                                <v-col cols="6">{{customer.tax_id}}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">ที่อยู่ : </v-col>
                                                <v-col>{{customer.address}} {{customer.postcode}}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">โทรศัพท์ : </v-col>
                                                <v-col cols="6">{{customer.phone_number}}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">อีเมล์ : </v-col>
                                                <v-col cols="6">{{customer.email}}</v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                -->
                                <v-col>
                                    <v-card>
                                        <v-card-subtitle class="header-color">
                                            
                                            สรุปค่าใช้จ่าย ({{ start_date}} - {{ end_date}})

                                        </v-card-subtitle>

                                        <v-divider></v-divider>

                                        <v-card-text>
                                            <v-data-table
                                                :headers="headers"
                                                :items="items"
                                                hide-default-footer
                                                group-by="group"
                                            >
                                        <template v-slot:group.header="{items, isOpen, toggle}">
                                            <th colspan="4" v-if="items[0].group != '9'">
                                            <v-icon @click="toggle"
                                                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                                            </v-icon>
                                            {{ items[0].group }}
                                            </th>
                                        </template>
                                        <template v-slot:item="props">
                                            <tr :style="{fontWeight: (props.item.idx == '50' ? 'bold' : 'normal')}">
                                            <td>{{props.item.item_name}}</td>
                                            <td>{{props.item.qty}}</td>
                                            <td>{{props.item.amountFormat}}</td>
                                            <td>{{props.item.totalFormat}}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                        </v-card-text>
                                        
                                    </v-card>
                                    
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col>
                            <v-card>
                                <v-card-subtitle class="header-color">รายละเอียดแพ็คเกจของลูกค้า</v-card-subtitle>
                                <v-divider></v-divider>
                                <v-card-text  class="text-left pr-5" style="text-align:left!important">
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">Package name </v-col>
                                        <v-col >{{selectedPackage.package_name}}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">รองรับสาขา</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.branch)}}</v-col>
                                    </v-row>
                                     <v-row>
                                         <v-col cols="1"></v-col>
                                        <v-col cols="6">บริการจองคิว</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.reservation)}}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">บริการนัดหมาย</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.appointment)}}</v-col>
                                    
                                    </v-row>
                                    <!--<v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">บริการข้อความแจ้งเตือนนัด ต่อเดือน</v-col>
                                        <v-col >
                                            {{selectedPackage.line_noti_per_month_display}}   / ข้อความ ต่อเดือน
                                        </v-col>
                                    </v-row>-->
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">Supervisor User</v-col>
                                        <v-col >
                                            {{selectedPackage.supervisor}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">Viewer User</v-col>
                                        <v-col >
                                            {{selectedPackage.viewer}}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <!--
                        <v-col>
                            <v-card>
                                <v-card-subtitle>ข้อมูลบริการเสริมของลูกค้า</v-card-subtitle>
                                <v-divider></v-divider>
                                <v-card-text  style="text-align:left!important">
                                    <v-list flat>
                                        <v-list-item-group
                                            color="primary"
                                        >
                                            <v-list-item
                                            v-for="(item, index) in extPackageList" :key="index">
                                                <v-list-item-icon>
                                                    <v-icon>mdi-check-circle</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-subtitle>
                                                        {{item.ext_package_name}}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        -->
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>
                <v-divider></v-divider>
            </v-card>
      </v-main>
    </v-app>
</template>

<style scoped>
    .right-text {
        text-align: right;
    }
    .header-color {
        background-color: aliceblue;
    }
</style>
<script>

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import moment from 'moment';
import Drawer from '@/components/Drawer.vue'
import numeral from 'numeral'
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'

export default {
    name: 'CustomerBillingDetail',
    components: {
      Drawer
      ,FragmentSelectStation
    },
    computed: {
        currentDate() {
            return moment(new Date().toISOString().substr(0, 10)).format('DD/MM/yyyy');
        },
        lineMessageProgress() {
            return this.lineMessage.current + "/" + this.lineMessage.total;
        }
    },
    watch: {
        "editedItem.period": function(val) {
            if (!val) return;
            this.editedItem.start_package_date = new Date().toISOString().substr(0, 10);
            var currentDate = moment(this.editedItem.start_package_date);
            var endDate = moment(currentDate).add(val, 'M').format('yyyy-MM-DD');
            this.editedItem.end_package_date = endDate;
        },
        "editedItem.package_id": function(val) {
            if (!val || this.packageList == undefined || this.packageList.length <= 0) return;
            this.selectedExtPackageList = new Array(this.extPackageList.length);
            this.selectedExtPackageQty = new Array(this.extPackageList.length);
        },
        selectedPackage(val) {
            if (val.line_noti_per_month == 0) val.line_noti_per_month = "0";
            if (val.supervisor == 0) val.supervisor = "0";
            if (val.viewer == 0) val.viewer = "0";
        }
    },
    data: () => ({
        rules: {
            required: value => !!value || 'กรุณากรอกข้อมูล.',
            requiredNumber: value => !!value && (value >= 0) || 'กรุณากรอกตัวเลขที่มีค่ามากกว่าหรือเท่ากับ 0',
        },
        headers: [
            {text: 'รายการ', value: 'item_name', width: '40%', groupable: false,},
            {text: 'จำนวน', value: 'qty', width: '20%', groupable: false,},
            {text: 'อัตราค่าใช้จ่าย', value: 'amountFormat', width: '20%', groupable: false,},
            {text: 'รวม', value: 'totalFormat', width: '20%', groupable: false,},
        ],
        items:[
            {idx: 0, group:'1. Package หลัก', item_name: 'ค่าธรรมเนียมสมาชิกในระบบ / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
            {idx: 1, group:'1. Package หลัก',item_name: 'ค่าธรรมเนียมสมาชิกที่รับข้อความ / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
            {idx: 2, group:'1. Package หลัก',item_name: 'ค่าบริการแพลตฟอร์ม / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
        ],
        lineMessage: {
            current: 10,
            total: 100
        },
        customer: {
            cust_name: '',
            address: '',
            postcode: '',
            tax_id: '',
            email: '',
            phone_number: ''
        },
        selectedPackage: {},
        packageList: [],
        extPackageList: [],
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        start_date: null,
        end_date: null
    }),
    methods: {
        onStationChange(station){
            document.location = station.station_code
        },
        getBooleanText(val) {
            return val == true ? "มีให้" : "ไม่มีให้";
        },
        loadPackage() {
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.customerpackage.get + this.customer.customer_id,
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                console.log(rs.data)
                this.selectedPackage = rs.data;
                this.selectedPackage.line_noti_per_month_display = numeral(this.selectedPackage.line_noti_per_month).format('0,0.00');
                this.loadExtPackage(this.selectedPackage.selectedExtPackageList);
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error}) 
            });
        },
        isOnTime(item) {
            if (!item) return 0;
            
            let currDate = moment(this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-15','yyyy-MM-DD')
            //let currDate = moment(new Date().toISOString().substr(0, 10)).set("date",15)
            let startDate = moment(item.start_package_date, 'DD-MM-yyyy').set("date",1)
            let endDate = moment(item.end_package_date, 'DD-MM-yyyy').set("date",25)
            
            let retVal = moment(currDate.format('yyyy-MM-DD')).isBetween(startDate.format('yyyy-MM-DD'), endDate.format('yyyy-MM-DD') );                    
            return retVal ? 1 : 0;
        },
        loadExtPackage(selectedExtPackage) {
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.ext_package.list_ext_package,
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                console.log(rs.data)
                this.extPackageList = [];
                if (rs.data && rs.data.length > 0) {
                    let sumDetail = 0;
                    if (!selectedExtPackage || selectedExtPackage.length <= 0) {this.setSummary(0);return;}
                    selectedExtPackage.forEach(o => {
                        let result = rs.data.find(e => e.ext_package_id == o.ext_package_id);
                        if (result) {
                            let qty = this.isOnTime(o);
                            if(qty>0){
                                result.qty = qty;
                                this.items.push(
                                    {
                                        idx: this.items.length,
                                        group: '2. บริการเสริม',
                                        item_name: result.ext_package_name,
                                        qty: qty,
                                        amount: result.unit_price,
                                        total: parseFloat(result.unit_price) * qty,
                                        amountFormat: numeral(result.unit_price).format('0,0.00'),
                                        totalFormat: numeral(parseFloat(result.unit_price) * qty).format('0,0.00')
                                    }
                                );
                                sumDetail += parseFloat(result.unit_price);
                                this.extPackageList.push(result);
                            }
                        }
                    });
                    this.setSummary(sumDetail);
                }
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error}) 
            });
        },
        fillData(srcItem, targetItem) {
            targetItem.line_noti_per_month = srcItem.line_noti_per_month;
            targetItem.supervisor = srcItem.supervisor;
            targetItem.viewer = srcItem.viewer;
            targetItem.line_noti_member_fee = srcItem.line_noti_member_fee;
            targetItem.member_fee = srcItem.member_fee;
            targetItem.platform_service_charge = srcItem.platform_service_charge;
        },
        loadMeta() {
            var que = this.$store.commit('addLoading')
            axios.post(
                config.api.url.manage.customer.customerbystationcode ,
                {station_code:this.$route.params.station_code},
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                this.customer = rs.data;
                if(this.customer.customer_id){
                    this.loadPackage();
                }else{
                    this.setSummary(0)
                }
            });
        },
        reloadMonth(){
            this.items = [
                {idx: 0, group:'1. Package หลัก', item_name: 'ค่าธรรมเนียมสมาชิกในระบบ / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
                {idx: 1, group:'1. Package หลัก',item_name: 'ค่าธรรมเนียมสมาชิกที่รับข้อความ / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
                {idx: 2, group:'1. Package หลัก',item_name: 'ค่าบริการแพลตฟอร์ม / เดือน', qty: 0, amount: 0,  amountFormat: '0', total: 0},
            ]
            if(this.customer.customer_id){
                    this.loadPackage();
            }else{
                    this.setSummary(0)
            }
        },
        setSummary(sumDetail) {

            var que = this.$store.commit('addLoading')
            var start_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-01'
            var d = new Date(start_date)
            d.setHours(d.getHours()+7)
            d.setMonth(d.getMonth()+1)
            d.setDate(d.getDate()-1)
            var end_date = d.toISOString().substring(0,10)

            if(this.customer.report_duedate && this.customer.report_duedate != null && this.customer.report_duedate > 0){
                var duedate = '00' + this.customer.report_duedate
                duedate = duedate.substring(duedate.length-2,duedate.length)
                end_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-' + duedate
                var d2 = new Date(end_date)
                d2.setHours(d2.getHours()+7)
                d2.setMonth(d2.getMonth()-1)
                d2.setDate(d2.getDate()+1)
                start_date = d2.toISOString().substring(0,10)
            }

            this.start_date = start_date
            this.end_date = end_date

            var qty1 = 0
            var qty2 = 0

            axios
            .post(config.api.url.manage.dashboard.get_memberstat,{
                station_code : this.$route.params.station_code
                ,start_date : start_date
                ,end_date : end_date
            },{ headers: Staff.getTokenHeader()}
            ).then(response => {
                this.desserts = []
                response.data.forEach(r => {
                    var d = new Date(r.date)
                    if(d<new Date()){
                        qty1 = r.allcount
                        qty2 = r.used_month
                    }
                });

                this.items[0].qty = qty1;
                this.items[0].amount = this.selectedPackage.member_fee ? this.selectedPackage.member_fee : 0;
                this.items[0].total = this.items[0].qty * this.items[0].amount;
                this.items[0].amountFormat = numeral(this.items[0].amount).format('0,0.00');
                this.items[0].totalFormat = numeral(this.items[0].total).format('0,0.00');

                this.items[1].qty = qty2;
                this.items[1].amount = this.selectedPackage.line_noti_member_fee ? this.selectedPackage.line_noti_member_fee : 0;
                this.items[1].total = this.items[1].qty * this.items[1].amount;
                this.items[1].amountFormat = numeral(this.items[1].amount).format('0,0.00');
                this.items[1].totalFormat = numeral(this.items[1].total).format('0,0.00');

                this.items[2].qty = 1;
                this.items[2].amount = this.selectedPackage.platform_service_charge ? this.selectedPackage.platform_service_charge : 0;
                this.items[2].total = this.items[2].qty * this.items[2].amount;
                this.items[2].amountFormat = numeral(this.items[2].amount).format('0,0.00');
                this.items[2].totalFormat = numeral(this.items[2].total).format('0,0.00');
                
                let sumItem = {idx: 50, group:'9',item_name: 'สรุปค่าใช้จ่ายทั้งสิ้น', total: (parseFloat(this.items[0].total) +
                                        parseFloat(this.items[1].total) +
                                        parseFloat(this.items[2].total) + sumDetail
                                    )};
                sumItem.totalFormat = numeral(sumItem.total).format('0,0.00');
                this.items.push(sumItem);
                
                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
            
        },
        getSumAmount() {
            return parseFloat(this.selectedPackage.member_fee) +
                   parseFloat(this.selectedPackage.line_noti_member_fee) +
                   parseFloat(this.selectedPackage.platform_service_charge) +
                   parseFloat(this.selectedPackage.line_noti_per_month);
        }
    },
    mounted() {
        this.loadMeta();
    }
}
</script>